export default {
    namespaced: true,
    state: {
        data: {}
    },
    getters: {
        data(state) {
            return state.data;
        },
        fieldData: state => (formId, fieldId) => {
            if (!state.data[formId]) return {};
            return state.data[formId][fieldId] || {};
        }
    },
    mutations: {
        data(state, data) {
            state.data = data;
        },
        fieldData(state, { formId, fieldId, data }) {
            state.data[formId][fieldId] = {
                ...state.data[formId][fieldId],
                ...data
            };
        }
    },
    actions: {
        async load({ dispatch, rootGetters }, revisionRef) {
            await dispatch('package/loadFromRef', revisionRef, { root: true });
            dispatch('loadFromData', rootGetters['package/pkg']);
        },
        loadFromData({ commit }, pkg) {
            let data = {};
            for (let id in pkg.form_instances) {
                data[id] = pkg.form_instances[id].form_data;
            }
            commit('data', data);
            commit('form/setForms', pkg.forms, { root: true });
        }
    }
};